__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "payments";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "17.3.12", () => (Promise.all([__webpack_require__.e(142), __webpack_require__.e(1965), __webpack_require__.e(2796), __webpack_require__.e(6443), __webpack_require__.e(8632)]).then(() => (() => (__webpack_require__(6443))))));
			register("@angular/common", "17.3.12", () => (Promise.all([__webpack_require__.e(142), __webpack_require__.e(316)]).then(() => (() => (__webpack_require__(316))))));
			register("@angular/core/primitives/signals", "17.3.12", () => (__webpack_require__.e(5689).then(() => (() => (__webpack_require__(5689))))));
			register("@angular/core/rxjs-interop", "17.3.12", () => (Promise.all([__webpack_require__.e(142), __webpack_require__.e(1965), __webpack_require__.e(2076), __webpack_require__.e(3351)]).then(() => (() => (__webpack_require__(9074))))));
			register("@angular/core", "17.3.12", () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(7580))))));
			register("@angular/router", "17.3.12", () => (Promise.all([__webpack_require__.e(142), __webpack_require__.e(1965), __webpack_require__.e(2796), __webpack_require__.e(8634), __webpack_require__.e(5273), __webpack_require__.e(8181), __webpack_require__.e(6651)]).then(() => (() => (__webpack_require__(8181))))));
			register("@jsverse/transloco", "7.5.1", () => (Promise.all([__webpack_require__.e(142), __webpack_require__.e(1965), __webpack_require__.e(9870), __webpack_require__.e(2137)]).then(() => (() => (__webpack_require__(9870))))));
			register("@ns/ngx-idp-authentication", "10.0.0", () => (Promise.all([__webpack_require__.e(142), __webpack_require__.e(1965), __webpack_require__.e(8634), __webpack_require__.e(395), __webpack_require__.e(169)]).then(() => (() => (__webpack_require__(169))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};